<p class="text-center">WYBIERZ E-RETAILERA</p>

<a *ngIf="data.friser_link" [href]="data.friser_link + '?utm_source=salonexpert.pl&utm_medium=referral&utm_campaign=strona_LP'" target="_blank" (click)="sendStat('friser')">
  <img src="/assets/images/shops/friser.webp" alt="">
</a>

<a *ngIf="data.hairstore_link" [href]="data.hairstore_link + '?utm_source=salonexpert.pl&utm_medium=referral&utm_campaign=strona_LP'" target="_blank" (click)="sendStat('hairstore')">
  <img src="/assets/images/shops/hairstore.webp" alt="">
</a>
